<template>

        <v-select
                
                multiple
                prepend-icon="category"
                :items="items"
                :item-text="'name'"
                :item-value="'id'"
                v-model="item"
                :label="$t('delivery.product.labels.categories')"
                :loading="loading"
                :error="hasInputErrors('categories')"
                :error-messages="getInputErrors('categories')"
                color="secondary"
                item-color="secondary"
                :rules="required"
        ></v-select>

</template>

<script>

    import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
    
    
    import ProductCategoryProvider from "../../../../providers/ProductCategoryProvider"

    export default {
        name: "ProductCategoryCombobox",
        mixins: [InputErrorsByProps, RequiredRule],
        props:{
            value: {
               type: [String, Array]
            },
        },
        data() {
            return {
                items: [],
                loading: false
            }
        },
        computed: {
           item: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
        mounted() {
         this.fetch()
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            },
            fetch(){
               this.loading= true
                ProductCategoryProvider.fetchProductCategory().then(r => {
                    this.items = r.data.fetchProductCategory
                }).catch(err => console.error(err))
                .finally(()=> this.loading = false)
            }
            
        }
    }
</script>

<style scoped>

</style>

